import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface EthanolWarningMessageStyles {
    container?: InjectableCss;
    warningMessage?: TypographyPresentationProps;
}

export const ethanolWarningMessageStyles: EthanolWarningMessageStyles = {
    container: {
        css: css`
            margin: 10px 0;
            padding: 15px;
            background-color: #f0f4f3;
            border-radius: 4px;
        `,
    },
    warningMessage: {
        color: "text",
        size: 14,
        css: css`
            display: block;
        `,
    },
};

const styles = ethanolWarningMessageStyles;

const EthanolWarningMessage: React.FC<Props> = ({ product }) => {
    if (!product || !product.properties || product.properties["ethanol"] !== "true") {
        return null;
    }

    const warningMessage = siteMessage("EthanolProductWarning") || 
        "Due to air regulations, this product cannot ship to addresses in Alaska or Hawaii. In conjunction with these regulations, this product can also only be shipped via ground transport in the contiguous 48 states, so delivery may take longer than usual.";

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.warningMessage}>
                {warningMessage}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(EthanolWarningMessage),
    definition: {
        group: "Product Details",
        icon: "exclamation-triangle",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule; 